import { API_ROOT } from "transport-layer/src"

const ApiInfo = () => {
  const environment = API_ROOT.split('.').pop();

  return (
    <span>API: {environment}</span>
  );
}

export default ApiInfo;
